module.exports = __webpack_public_path__ + "img/yunshanfu.9e1f6153.svg";